export default "__VITE_ASSET__4d3ed93e__"